import { onReadyEventMap } from '../comp.root.js';
import { PrinterState } from '../store.js';

/**
 * based on the provided print configuration this callback will populate our
 * print container with the provided content, trigger relevant layout phases
 * and finally triggering the optional onReady callback once the print
 * container has settled.
 */
function populatePrintTarget(key, target, input, onReady) {
  if (PrinterState.current?.contentKey === key) {
    onReady?.();
    return;
  }
  PrinterState.current = {
    contentKey: key,
    target: target,
    input: input
  };
  const hasTriggered = onReadyEventMap.get(key)?.triggered;
  if (hasTriggered) {
    onReady?.();
    return;
  }
  onReadyEventMap.clear();
  if (onReady) {
    onReadyEventMap.set(key, {
      triggered: false,
      cb: onReady
    });
  }
}

export { populatePrintTarget };
//# sourceMappingURL=_populate-print-target.js.map
